import React from "react";
import { useEffect } from "react";
import { pushOrderConfirmationPageEvent } from "../Actions/Gtm.action";
import { trackSale } from "../Actions/HelloRetail.action";

function ConversionTracking(props) {

  const { orderId } = JSON.parse(props.order);

  useEffect(() => {
    setTimeout(() => {
      pushOrderConfirmationPageEvent(orderId);
      trackSale(props.order);
    }, 5000);    
  }, []);

  return null;
}

export default ConversionTracking;
